import { types } from "mobx-state-tree";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export interface ClinicInstance extends Instance<typeof Clinic> {}
export interface ClinicSnapshotIn extends SnapshotIn<typeof Clinic> {}
export interface ClinicSnapshotOut extends SnapshotOut<typeof Clinic> {}

export const Clinic = types.model("Clinic", {
  id: types.identifier,
  name: types.string,
  streetAddress: types.maybeNull(types.string),
  city: types.maybeNull(types.string),
  zipCode: types.maybeNull(types.string),
  latitude: types.maybeNull(types.number),
  longitude: types.maybeNull(types.number),
  phone: types.maybeNull(types.string),
  website: types.maybeNull(types.string),
});
